const google = window.google;

function new_map($el) {
  var $markers = $el.find('.marker');
  var args = {
    zoom: 14,
    center: new google.maps.LatLng($el.attr('data-main-lat'), $el.attr('data-main-lng')),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    scrollwheel: false,
    navigationControl: false,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    draggable: true,
    disableDefaultUI: true,
    styles: [
      {
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f5f5f5',
          },
        ],
      },
      {
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off',
          },
        ],
      },
      {
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#616161',
          },
        ],
      },
      {
        'elementType': 'labels.text.stroke',
        'stylers': [
          {
            'color': '#f5f5f5',
          },
        ],
      },
      {
        'featureType': 'administrative.land_parcel',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#bdbdbd',
          },
        ],
      },
      {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#eeeeee',
          },
        ],
      },
      {
        'featureType': 'poi',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#757575',
          },
        ],
      },
      {
        'featureType': 'poi.park',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#e5e5e5',
          },
        ],
      },
      {
        'featureType': 'poi.park',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#9e9e9e',
          },
        ],
      },
      {
        'featureType': 'road',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#ffffff',
          },
          {
            'weight': 0.5,
          },
        ],
      },
      {
        'featureType': 'road.arterial',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#757575',
          },
        ],
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#dadada',
          },
        ],
      },
      {
        'featureType': 'road.highway',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#616161',
          },
        ],
      },
      {
        'featureType': 'road.local',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#9e9e9e',
          },
        ],
      },
      {
        'featureType': 'transit.line',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#e5e5e5',
          },
        ],
      },
      {
        'featureType': 'transit.station',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#eeeeee',
          },
        ],
      },
      {
        'featureType': 'water',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#c9c9c9',
          },
        ],
      },
      {
        'featureType': 'water',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#9e9e9e',
          },
        ],
      },
    ],
  };
  var map = new google.maps.Map($el[0], args);
  map.markers = [];
  var currentIter = 999999;
  $markers.each(function () {
    currentIter -= 1;
    add_marker($(this), map, currentIter);
  });
  center_map(map);
  return map;
}

function add_marker($marker, map, key) {

  var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
  var properSize = (jQuery($marker).data('icon').toLowerCase().indexOf('blumenthal.png') >= 0) ? new google.maps.Size(126, 126) : new google.maps.Size(40, 40);
  var properAnchor = (jQuery($marker).data('icon').toLowerCase().indexOf('blumenthal.png') >= 0) ? new google.maps.Point(58, 58) : new google.maps.Point(40, 40);

  var icon = {
    url: jQuery($marker).data('icon'),
    scaledSize: properSize,
    anchor: properAnchor,
  };

  var marker = new google.maps.Marker({
    position: latlng,
    icon: icon,
    zIndex: key,
    map: map,
  });

  map.markers.push(marker);
}

function center_map(map) {
  var bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function (i, marker) {
    var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
    bounds.extend(latlng);
  });
}

$(document).ready(function () {
  $('.acf-map').each(function () {
    // eslint-disable-next-line
    var map;
    map = new_map($('.acf-map'));
  });
});



// WEBPACK FOOTER //
// ./scripts/util/googlemaps.js